var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.84 32 32 24.84 32 16C32 7.16 24.84 0 16 0C7.16 0 0 7.16 0 16C0 24.84 7.16 32 16 32Z",
    fill: "#1C6C2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.96 17.1067C17.8533 17.1067 17.28 17.1467 16.0133 17.1467C15 17.1467 14.2933 17.12 14.04 17.1067C10.1467 16.9333 7.25335 16.2533 7.25335 15.4533C7.25335 14.6533 10.16 13.9733 14.04 13.7867V16.4267C14.2933 16.44 15.0267 16.4933 16.0267 16.4933C17.24 16.4933 17.84 16.44 17.9467 16.44V13.8C21.8267 13.9733 24.72 14.6533 24.72 15.4533C24.7333 16.2533 21.84 16.9333 17.96 17.1067ZM17.96 13.52V11.1467H23.3733V7.54666H8.64001V11.16H14.0533V13.52C9.65335 13.72 6.34668 14.6 6.34668 15.64C6.34668 16.68 9.65335 17.56 14.0533 17.76V25.3333H17.96V17.7467C22.3467 17.5467 25.6533 16.68 25.6533 15.6267C25.6533 14.5733 22.36 13.72 17.96 13.52Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.535cfca48d1b0327c8412499b8881dd5.svg";
export { ForwardRef as ReactComponent };